// extracted by mini-css-extract-plugin
module.exports = {"int":"DomainsRealPositonAvgCell_int__3KofX","float":"DomainsRealPositonAvgCell_float__3ZX2i"};